


import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { SelectionPanelOption } from '../SelectionPanel/SelectionPanel.models';
import { Module } from '../../utils/api';

@Component({})
export default class VerticalSelect extends Vue {
  @Prop() private options!: SelectionPanelOption[] | Module[];

  @Emit()
  private selectOption(option: SelectionPanelOption | Module) {
    return option;
  }
}
